import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {FaxeStore} from '@app/store/faxe/faxe-store-model';
import {FenceResultEntityState} from '@app/store/faxe/fence-result/fence-result.reducer';
import {FenceEntityState} from '@app/store/faxe/fences/fence.reducer';
import {ResultCodeEntityState} from '@app/store/faxe/results-code/result-code.reducer';
import {RaceClassEntityState} from '@app/store/faxe/race-class/race-class.reducer';
import {ClubLogoEntityState} from '@app/store/faxe/club-logo/club-logo.reducer';
import {RiderEventEntityState} from '@app/store/faxe/rider-event/rider-event.reducer';
import {RiderEntityState} from '@app/store/faxe/rider/rider.reducer';
import { RaceEntityState } from '@app/store/faxe/race/race.reducer';
import { MultiContractDataEntityState } from '@app/store/faxe/multi-contract/multi-contract-reducer';


export const getFaxeState: MemoizedSelector<
  object,
  FaxeStore
  > = createFeatureSelector<FaxeStore>('faxe');

export const getRiderState: MemoizedSelector<
  object,
  RiderEntityState
  > = createSelector(getFaxeState, (state) => state.rider);

export const getMultiContractDataState: MemoizedSelector<
  object,
  MultiContractDataEntityState
> = createSelector(getFaxeState, (state) => state.multiContractData);

export const getFenceResultState: MemoizedSelector<
  object,
  FenceResultEntityState
  > = createSelector(getFaxeState, (state) => state.fenceResult);

export const getFenceState: MemoizedSelector<
  object,
  FenceEntityState
  > = createSelector(getFaxeState, (state) => state.fence);

export const getResultCodesState: MemoizedSelector<
  object,
  ResultCodeEntityState
  > = createSelector(getFaxeState, (state) => state.resultCode);

export const getRacesState: MemoizedSelector<
  object,
  RaceEntityState
> = createSelector(getFaxeState, (state) => state.race);

export const geRiderEventsState: MemoizedSelector<
  object,
  RiderEventEntityState
  > = createSelector(getFaxeState, (state) => state.riderEvent);

export const getRaceClassState: MemoizedSelector<
  object,
  RaceClassEntityState
  > = createSelector(getFaxeState, (state) => state.raceClass);

export const getClubLogoState: MemoizedSelector<
  object,
  ClubLogoEntityState
  > = createSelector(getFaxeState, (state) => state.clubLogo);
